"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", ";\n  border: none;\n  border-radius: 18px;\n  box-sizing: border-box;\n  ", ";\n"], ["\n  ", ";\n  border: none;\n  border-radius: 18px;\n  box-sizing: border-box;\n  ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n"], ["\n  display: flex;\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n"]);

var _buoyButton = require("buoy-button");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Card = require("./Card");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BlankPromoCard = _styledComponents2.default.div.withConfig({
  displayName: "PromoCard__BlankPromoCard",
  componentId: "ngkxh6-0"
})(_templateObject, _Card.CardStyle, function (props) {
  return (0, _buoyTheme.responsive)("width", props.width, props.width, props.width, props.width, "100%");
});

var ChatIconWrapper = _styledComponents2.default.div.withConfig({
  displayName: "PromoCard__ChatIconWrapper",
  componentId: "ngkxh6-1"
})(_templateObject2);

var BuoyChatIcon = function BuoyChatIcon(_ref) {
  var theme = _ref.theme;
  return _react2.default.createElement(
    "svg",
    { width: "100%", height: "100%", x: "0px", y: "0px", viewBox: "0 0 32 32" },
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", {
        fill: "white",
        d: "M16,32H0l0-16C0,7.2,7.2,0,16,0h0c8.8,0,16,7.2,16,16v0C32,24.8,24.8,32,16,32z"
      }),
      _react2.default.createElement("path", {
        fill: theme.colors.primary,
        d: "M21.6,18.5c0-3.1-2.5-5.6-5.6-5.6c-1,0-2,0.3-2.8,0.8l0-5.3c0-0.9-0.6-1.6-1.4-1.6h0h0h-1.4c0,0,0,11.7,0,11.7 c0,3.1,2.5,5.6,5.6,5.6C19,24.1,21.6,21.6,21.6,18.5z M18.8,18.5c0,1.6-1.3,2.8-2.8,2.8s-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8 S18.8,16.9,18.8,18.5z"
      })
    )
  );
};

BuoyChatIcon = (0, _styledComponents.withTheme)(BuoyChatIcon);

var WrappedBuoyChatIcon = function WrappedBuoyChatIcon() {
  return _react2.default.createElement(
    ChatIconWrapper,
    null,
    _react2.default.createElement(BuoyChatIcon, null)
  );
};

var PromoCard = function PromoCard(_ref2) {
  var btnText = _ref2.btnText,
      link = _ref2.link,
      children = _ref2.children,
      className = _ref2.className,
      width = _ref2.width;
  return _react2.default.createElement(
    BlankPromoCard,
    { className: className, width: width },
    children,
    _react2.default.createElement(
      _buoyButton.RoundLinkButton,
      { href: link },
      _react2.default.createElement(WrappedBuoyChatIcon, null),
      btnText
    )
  );
};

PromoCard.defaultProps = {
  width: '356px'
};

PromoCard.propTypes = {
  btnText: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.string.isRequired
};

exports.default = PromoCard;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-card/dist/components/PromoCard.js
// module id = 395
// module chunks = 168707334958949